<app-header></app-header>
<div id="main">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>